import { GameLayoutRenderProps } from './props';

import styles from '../styles.module.scss';
import { ErrorCard } from '@starsoft/common/components';
import { useWalletsMe } from '@/api/wallets';
import { useUserAccount } from '@/api/user';

function GameLayoutRender({
  board,
  error,
  panel,
  useColumnLayout,
  refetch,
}: GameLayoutRenderProps) {
  const { error: errorWalletsMe, refetch: refetchWalletsMe } = useWalletsMe();
  const { error: errorUserAccount, refetch: refetchUserAccount } =
    useUserAccount();

  const currentError = error || errorWalletsMe || errorUserAccount;

  function handleError() {
    if (error) {
      refetch();
    }

    if (errorWalletsMe) {
      refetchWalletsMe();
    }

    if (errorUserAccount) {
      refetchUserAccount();
    }
  }

  if (currentError) {
    return <ErrorCard error={currentError} refetch={handleError} />;
  }

  return (
    <div
      className={`${styles.container__game__wrapper} ${useColumnLayout ? styles['container__game__wrapper--column'] : ''}`}
    >
      {panel && (
        <div className={styles.container__game__wrapper__panel}>{panel}</div>
      )}
      <div className={styles.container__game__wrapper__board}>{board}</div>
    </div>
  );
}

export default GameLayoutRender;
